import React,{createContext,useContext,useEffect,useMemo,useState} from 'react';
import {waitForPendingWrites} from 'firebase/firestore';
import {db} from '../firebase';

const NetworkContext=createContext({online:true,status:'online',pendingWrites:0});
const PENDING_KEY='coachsphere_pending_writes';

function storedPending(){try{return Math.max(0,Number(localStorage.getItem(PENDING_KEY)||0))}catch{return 0}}
function persistPending(value){try{localStorage.setItem(PENDING_KEY,String(Math.max(0,value)))}catch{}}

export function NetworkProvider({children}){
  const [online,setOnline]=useState(typeof navigator==='undefined'?true:navigator.onLine);
  const [pendingWrites,setPendingWrites]=useState(storedPending);
  const [syncing,setSyncing]=useState(false);

  useEffect(()=>{
    let cancelled=false;
    const settlePending=async()=>{
      if(!navigator.onLine||storedPending()<=0)return;
      setSyncing(true);
      try{
        await waitForPendingWrites(db);
        if(cancelled)return;
        persistPending(0);setPendingWrites(0);
        window.dispatchEvent(new CustomEvent('coachsphere:writes-synced'));
      }catch{/* keep pending count visible until the next successful reconnect */}
      finally{if(!cancelled)setSyncing(false)}
    };
    const onOnline=()=>{setOnline(true);settlePending()};
    const onOffline=()=>setOnline(false);
    const onPending=(event)=>{const delta=Number(event.detail?.delta||1);const next=Math.max(0,storedPending()+delta);persistPending(next);setPendingWrites(next)};
    const onSynced=()=>{persistPending(0);setPendingWrites(0);setSyncing(false)};
    window.addEventListener('online',onOnline);window.addEventListener('offline',onOffline);window.addEventListener('coachsphere:pending-write',onPending);window.addEventListener('coachsphere:writes-synced',onSynced);
    if(navigator.onLine&&storedPending()>0)settlePending();
    return()=>{cancelled=true;window.removeEventListener('online',onOnline);window.removeEventListener('offline',onOffline);window.removeEventListener('coachsphere:pending-write',onPending);window.removeEventListener('coachsphere:writes-synced',onSynced)};
  },[]);

  const status=!online?'offline':syncing||pendingWrites>0?'syncing':'online';
  const value=useMemo(()=>({online,status,pendingWrites}),[online,status,pendingWrites]);
  return <NetworkContext.Provider value={value}>{children}</NetworkContext.Provider>;
}
export function useNetwork(){return useContext(NetworkContext)}
